export default __webpack_public_path__ + "f41b63c0bb0963ace821a2b99458c1cd.ttf";